import styled from '@emotion/styled';

export const ClassesWrapper = styled.div`
  max-width: 735px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const CareerWrap = styled.div`
  max-width: 735px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const ClassesData = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  align-content: center;
  grid-gap: 55px;
  column-gap: 53px;
  list-style: none;
  margin: 0;
  padding: 0;
  padding-bottom: 95px;
  img {
    display: grid;
    align-content: center;
    width: 100%;

    @media (max-width: 900px) {
      height: 60px;
    }
  }
  @media (max-width: 900px) {
    padding-bottom: 0;
    grid-template-columns: 1fr;
    grid-gap: 35px;
  }
`;
export const ClassesCard = styled.div<{
  gridCenter?: boolean;
}>`
  border: 1.5px solid #b5e8ff;
  border-radius: 20px;
  padding: 50px 0px 29px 0px;
  bottom: 0px;
  min-height: 510px;
  box-sizing: border-box;
  display: ${props => (props.gridCenter ? 'grid' : 'block')};
  place-content: ${props => (props.gridCenter ? 'center' : 'initial')};
  display: flex;
  flex-direction: column;
  @media (max-width: 599px) {
    min-height: 440px;
    padding: 40px 0px 40px 0px;
  }
`;
export const CardHeading = styled.div`
  display: grid;
  justify-content: center;
  align-content: center;
  color: #172643;
  font-family: proxima-nova, sans-serif;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 1.25px;
  line-height: 28px;
  padding: 37px 0 17px 0;
  text-transform: uppercase;

  @media (max-width: 599px) {
    padding: 37px 0 8px 0;
    font-size: 16px;
  }
}
`;
export const CardDetails = styled.div<{
  maximunWidth?: string;
}>`
  color: #737373;
  font-family: proxima-nova, sans-serif;
  font-weight: 300;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  max-width: ${props => (props.maximunWidth ? props.maximunWidth : '482px')};
  margin: auto;
  padding: 0px 20px;
  box-sizing: border-box;

  @media (max-width: 599px) {
    padding: 0px 29px;
    font-size: 14px;
    line-height: 25px;
  }
`;
export const ClassesBooknow = styled.div`
text-align: center;
margin-top: auto;
  @media (max-width: 599px) {
    padding: 0px 29px;
  }
}
`;
